import React, { useEffect, useRef, useState } from 'react';
import { Mail, Phone, MapPin, Send, Clock } from 'lucide-react';
import './Contact.css';

export default function ContactForm() {
  const headingRef = useRef(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch('mailto:trigovextechnologies@gmail.com', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to: 'sales@sealactive.com',
        ...formData,
      }),
    });

    if (response.ok) {
      alert('Message sent successfully!');
      // Optionally reset the form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });
    } else {
      alert('Failed to send message.');
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-visible');
        }
      },
      { threshold: 0.1 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="contact-section">
      <div className="container">
        <div className="max-width">
          <div className="header">
            <h1 className="sec-head">
            Request Call Back!
            </h1>
          </div>

          <div className="grid-container">
            {/* Contact Information */}
            <div className="contact-info">
              <div className="info-content">
                <h3 className="info-title">Contact Information</h3>
                <div className="info-item">
                  <div className="icon-wrapper">
                    <Phone />
                  </div>
                  <div>
                    <p className="info-label">Phone</p>
                    <p className="info-detail">+91 9611589138 , 9964192505</p>
                  </div>
                </div>
                <div className="info-item">
                  <div className="icon-wrapper">
                    <Mail />
                  </div>
                  <div>
                    <p className="info-label">Email</p>
                    <p className="info-detail">sales@sealactive.in</p>
                  </div>
                </div>
                <div className="info-item">
                  <div className="icon-wrapper">
                    <MapPin />
                  </div>
                  <div>
                    <p className="info-label">Address</p>
                    <p className="info-detail">10, Balaji Layout, Mallathahalli, Banglore, 560056</p>
                  </div>
                </div>
                <div className="info-item">
                  <div className="icon-wrapper">
                    <Clock />
                  </div>
                  <div>
                    <p className="info-label">Business Hours</p>
                    <p className="info-detail">Mon - Fri: 9:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
              <div className="mt-12 follow-us">
  <h4 className="font-medium mb-4">Follow Us</h4>
  <div className="flex space-x-4">
    {['facebook', 'twitter', 'linkedin', 'instagram'].map((social) => (
      <a
        key={social}
        href={`https://${social}.com`}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-500/30 p-2 rounded-lg hover:bg-blue-500/50 transition-colors"
      >
        <img
          src={`https://api.iconify.design/simple-icons/${social}.svg?color=white`}
          alt={social}
          className="w-5 h-5"
        />
      </a>
    ))}
  </div>
</div>
            </div>

            {/* Contact Form */}
            <div className="contact-form" style={{ backgroundColor: 'black', border: '1px solid lightSkyBlue', padding: '20px', borderRadius: '10px' }}>
              <form className="form" onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-group">
                    <label style={{ color: 'white' }}>First Name</label>
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="Seal" className="glassmorphism-input" style={{ backgroundColor: 'black' }} />
                  </div>
                  <div className="form-group">
                    <label style={{ color: 'white' }}>Last Name</label>
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Active" className="glassmorphism-input" style={{ backgroundColor: 'black' }} />
                  </div>
                </div>

                <div className="form-grid">
                  <div className="form-group">
                    <label style={{ color: 'white' }}>Email</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="contact@sealactive.com" className="glassmorphism-input" style={{ backgroundColor: 'black' }} />
                  </div>
                  <div className="form-group">
                    <label style={{ color: 'white' }}>Phone Number</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 9876543210" className="glassmorphism-input" style={{ backgroundColor: 'black' }} />
                  </div>
                </div>

                <div className="form-group">
                  <label style={{ color: 'white' }}>Subject</label>
                  <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="How can we help you?" className="glassmorphism-input" style={{ backgroundColor: 'black' }} />
                </div>

                <div className="form-group">
                  <label style={{ color: 'white' }}>Message</label>
                  <textarea name="message" rows={4} value={formData.message} onChange={handleChange} placeholder="Write your message here..." className="glassmorphism-input" style={{ backgroundColor: 'black' }}></textarea>
                </div>

                <button type="submit" className="submit-button">
                  <span>Send Message</span>
                  <Send />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
